import { api } from '@/lib/axios';
import { SampleUserType } from '@/features/create-samples/types/sample.types';
export type { SampleUserType };

export interface SampleUserTypeSearchParams {
  sampleDateFrom?: string;
  sampleDateTo?: string;
  sampleTypeId?: number;
  userId?: number;
  status?: string;
  observations?: string;
}



export const searchSampleUserTypes = async (params: SampleUserTypeSearchParams): Promise<SampleUserType[]> => {
  try {
    const { data } = await api.post<SampleUserType[]>('/api/sample-user-types/search', params);
    return data;
  } catch (error) {
    console.error('Error al buscar tipos de usuario de muestras:', error);
    throw new Error('Error al buscar tipos de usuario de muestras');
  }
};

export interface SampleExportParams {
  sampleDate?: string;
  sampleTypeId?: number;
  sampleUserId?: number;
  sampleRecordStatusId?: number;
  accommodationId?: string;
}

export const exportSampleToExcel = async (params: SampleExportParams): Promise<Blob> => {
  const { data } = await api.post('/api/samples/search/export-excel', params, {
    responseType: 'blob',
  });
  return data;
}; 